import { api } from './api';

export const productPlansService = {
  async list(productId: number) {
    const r = await api.get(`/products/${productId}/plans`);
    return r.data;
  },
  async create(productId: number, data: { slug: string; name: string; order?: number }) {
    const r = await api.post(`/products/${productId}/plans`, data);
    return r.data;
  },
  async update(
    productId: number,
    planId: number,
    data: { name?: string; order?: number; active?: boolean; slug?: string }
  ) {
    const r = await api.patch(`/products/${productId}/plans/${planId}`, data);
    return r.data;
  },
  async delete(productId: number, planId: number) {
    const r = await api.delete(`/products/${productId}/plans/${planId}`);
    return r.data;
  },
};
